export default '/pricing/mail/payment';
